export default __webpack_public_path__ + "img/de13be50cee66326ec76c88a13b6417a.png";